import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable, of } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Ean, jsonToEan } from '../models/ean.model';
import _ from 'lodash';
import { DailyConsumptionBetweenDatesResult } from '../models/daily-consumption-between-dates-result.model';
import { MonthlyConsumptionBetweenDatesResult } from '../models/montly-consumption-between-dates-result.model';
import { QuarterlyConsumptionBetweenDatesResult } from '../models/quarterly-consumption-between-dates-result.model';
import { QuarterlyConsumptionResult } from '../models/quarterly-consumption.model';
import { YearlyConsumptionBetweenDatesResult } from '../models/yearly-consumption-between-dates-result.model';

@Injectable()
export class ConsumptionService {
  constructor(private http: HttpClient) {}

  getDailyConsumption(ean: Ean, date: Date): Observable<DailyConsumptionBetweenDatesResult[]> {
    var startDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0, 0));
    var endDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), 23, 59, 59, 999));
    return this.http.get<DailyConsumptionBetweenDatesResult[]>(`${environment.baseUrl}/api/Consumption/GetDailyConsumptionBetweenDates?ean=${ean.ean}&startDate=${startDate.toISOString().replace('Z', '')}&endDate=${endDate.toISOString().replace('Z', '')}`);
  }

  getDailyConsumptionBetweenDates(ean: Ean, startDate: Date, endDate: Date): Observable<DailyConsumptionBetweenDatesResult[]> {
    return this.http.get<DailyConsumptionBetweenDatesResult[]>(`${environment.baseUrl}/api/Consumption/GetDailyConsumptionBetweenDates?ean=${ean.ean}&startDate=${startDate.toISOString().replace('Z', '')}&endDate=${endDate.toISOString().replace('Z', '')}`);
  }

  getWeeklyConsumption(ean: Ean, date: Date): Observable<DailyConsumptionBetweenDatesResult[]> {
    var startDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate() - date.getDay(), 0, 0, 0, 0));
    var endDate = startDate.addWeeks(1);
    return this.http.get<DailyConsumptionBetweenDatesResult[]>(`${environment.baseUrl}/api/Consumption/GetDailyConsumptionBetweenDates?ean=${ean.ean}&startDate=${startDate.toISOString().replace('Z', '')}&endDate=${endDate.toISOString().replace('Z', '')}`);
  }

  getWeeklyConsumptionBetweenDates(ean: Ean, startDate: Date, endDate: Date): Observable<DailyConsumptionBetweenDatesResult[]> {
    return this.http.get<DailyConsumptionBetweenDatesResult[]>(`${environment.baseUrl}/api/Consumption/GetDailyConsumptionBetweenDates?ean=${ean.ean}&startDate=${startDate.toISOString().replace('Z', '')}&endDate=${endDate.toISOString().replace('Z', '')}`);
  }

  getMonthlyConsumption(ean: Ean, date: Date): Observable<MonthlyConsumptionBetweenDatesResult[]> {
    var startDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), 1, 0, 0, 0, 0));
    var endDate = startDate.addMonths(1);
    return this.http.get<MonthlyConsumptionBetweenDatesResult[]>(`${environment.baseUrl}/api/Consumption/GetMonthlyConsumptionBetweenDates?ean=${ean.ean}&startDate=${startDate.toISOString().replace('Z', '')}&endDate=${endDate.toISOString().replace('Z', '')}`);
  }

  getMonthlyConsumptionBetweenDates(ean: Ean, startDate: Date, endDate: Date): Observable<MonthlyConsumptionBetweenDatesResult[]> {
    return this.http.get<MonthlyConsumptionBetweenDatesResult[]>(`${environment.baseUrl}/api/Consumption/GetMonthlyConsumptionBetweenDates?ean=${ean.ean}&startDate=${startDate.toISOString().replace('Z', '')}&endDate=${endDate.toISOString().replace('Z', '')}`);
  }

  getQuarterlyConsumptionBetweenDates(ean: Ean, startDate: Date, endDate: Date): Observable<QuarterlyConsumptionBetweenDatesResult[]> {
      return this.http.get<QuarterlyConsumptionBetweenDatesResult[]>(`${environment.baseUrl}/api/Consumption/GetQuarterlyConsumptionBetweenDates?ean=${ean.ean}&startDate=${startDate.toDateString()}&endDate=${endDate.toDateString()}`);
  }

  getQuarterlyConsumption(ean: Ean, date: Date): Observable<QuarterlyConsumptionResult[]> {
      return this.http.get<QuarterlyConsumptionResult[]>(`${environment.baseUrl}/api/Consumption/GetQuarterlyConsumption?ean=${ean.ean}&date=${date.toDateString()}`);
  }

  getYearlyConsumption(ean: Ean, date: Date): Observable<YearlyConsumptionBetweenDatesResult[]> {
    var startDate = new Date(Date.UTC(date.getFullYear(), 0, 1, 0, 0, 0, 0));
    var endDate = new Date(Date.UTC(date.getFullYear(), 11, 31, 23, 59, 59, 999));
    return this.http.get<YearlyConsumptionBetweenDatesResult[]>(`${environment.baseUrl}/api/Consumption/GetYearlyConsumptionBetweenDates?ean=${ean.ean}&startDate=${startDate.toISOString().replace('Z', '')}&endDate=${endDate.toISOString().replace('Z', '')}`);
  }

  getYearlyConsumptionBetweenDates(ean: Ean, startDate: Date, endDate: Date): Observable<YearlyConsumptionBetweenDatesResult[]> {
    return this.http.get<YearlyConsumptionBetweenDatesResult[]>(`${environment.baseUrl}/api/Consumption/GetYearlyConsumptionBetweenDates?ean=${ean.ean}&startDate=${startDate.toISOString().replace('Z', '')}&endDate=${endDate.toISOString().replace('Z', '')}`);
  }
}
